import React from 'react';
import PropTypes from 'prop-types';

import DialogsWithIcon from '@Containers/Dialogs/DialogsWithIcon';
import Button from '@Components/Button';
import './AccountErrorModal.custom.scss';

function AccountErrorModal({ selfClose, error }) {
  return (
    <DialogsWithIcon
      size="sm"
      movable={false}
      className="react-dialogs-scrollable account-error-modal"
      headerClassName="rx-border-none"
      footerClassName="rx-border-none"
      layoutType="error"
      character="i"
      selfClose={selfClose}
      closeBtn={false}
      header={error.errorName}
      footer={
        <Button
          onClick={selfClose}
          buttonConfig={{
            label: 'Ok, got it',
            className: 'els-btn-link',
            type: 'link',
            size: 'sm',
            e2eName: 'e2e-name',
          }}
          iconConfig={{ name: 'chevron-right' }}
        />
      }>
      {error.errorMessage}
    </DialogsWithIcon>
  );
}

AccountErrorModal.propTypes = {
  selfClose: PropTypes.func.isRequired,
  error: PropTypes.shape({ errorName: PropTypes.string, errorMessage: PropTypes.string }),
};

export default AccountErrorModal;
